<template>
  <div class="channel-dropdown pa-2">
    <v-select
      v-model="selectedItem"
      :items="channels"
      :loading="loading"
      item-value="platformConnectionID"
      return-object
      hide-details
      outlined
      dense
      :placeholder="use_language.choose + ' channel'"
      :menu-props="{ offsetY: true, maxHeight: 400 }"
      @change="onChange"
    >
      <!-- ของที่โชว์ในช่อง input -->
      <template v-slot:selection="{ item }">
        <div class="d-flex align-center" style="width: 100%; min-width: 0">
          <v-avatar size="28" class="mr-2">
            <v-img
              v-if="item.platformShopProfilePicture"
              :src="item.platformShopProfilePicture"
            />
            <v-icon
              v-else
              :color="platformColor(item.platformID)"
              size="22"
            >
              {{ platformIcon(item.platformID) }}
            </v-icon>
          </v-avatar>
          <span class="text-truncate flex-grow-1">
            {{ displayName(item) }}
          </span>
          <v-chip
            v-if="getUnread(item) > 0"
            x-small
            color="error"
            text-color="white"
            class="ml-1 px-2"
          >
            {{ getUnread(item) }}
          </v-chip>
        </div>
      </template>

      <!-- รายการใน dropdown menu -->
      <template v-slot:item="{ item, on, attrs }">
        <v-list-item v-bind="attrs" v-on="on" class="px-2">
          <v-list-item-avatar size="32">
            <v-img
              v-if="item.platformShopProfilePicture"
              :src="item.platformShopProfilePicture"
            />
            <v-icon
              v-else
              :color="platformColor(item.platformID)"
              size="26"
            >
              {{ platformIcon(item.platformID) }}
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="text-truncate">
              {{ displayName(item) }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-chip
                x-small
                dark
                :color="platformColor(item.platformID)"
                class="px-2"
              >
                {{ platformName(item.platformID) }}
              </v-chip>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="getUnread(item) > 0">
            <v-chip x-small color="error" text-color="white" class="px-2">
              {{ getUnread(item) }}
            </v-chip>
          </v-list-item-action>
        </v-list-item>
      </template>

      <!-- empty state -->
      <template v-slot:no-data>
        <div class="py-4 text-center" style="color: grey">
          <v-icon color="grey lighten-1">mdi-inbox-outline</v-icon>
          <div class="caption mt-1">{{ use_language.not_have }} channel</div>
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import axios from "axios";
import { expressService_dotnet } from "@/website/global";
import { token_api } from "@/website/backend/token";
import { get_languages } from "@/website/global_function";
import {
  PLATFORM_NAME,
  PLATFORM_COLOR,
  PLATFORM_ICON,
} from "./constants";

export default {
  name: "ChannelDropdown",
  props: {
    shopId: { type: [String, Number], required: true },
    activeId: { type: [String, Number], default: null },
  },
  data: () => ({
    channels: [],
    selectedItem: null,
    loading: false,
    use_language: {},
  }),
  watch: {
    // sync ถ้า parent เปลี่ยน activeId มา
    activeId(val) {
      if (val == null) return;
      const found = this.channels.find(
        (c) => c.platformConnectionID === val
      );
      if (found && (!this.selectedItem || this.selectedItem.platformConnectionID !== val)) {
        this.selectedItem = found;
      }
    },
  },
  async created() {
    this.use_language = await this.get_languages(localStorage.getItem("set_language"));
    this.loadChannels();
  },
  methods: {
    get_languages,
    platformName(id) {
      return PLATFORM_NAME[id] || "Other";
    },
    platformColor(id) {
      return PLATFORM_COLOR[id] || "grey";
    },
    platformIcon(id) {
      return PLATFORM_ICON[id] || "mdi-account-circle";
    },
    displayName(item) {
      if (!item) return "";
      return (
        item.platformShopName ||
        this.platformName(item.platformID) + "." + item.id
      );
    },
    // backend อาจส่ง field unread มาในชื่อต่างกัน — รองรับทั้ง 3 แบบ
    getUnread(item) {
      if (!item) return 0;
      return item.unreadCount || item.totalUnread || item.unread || 0;
    },
    async loadChannels() {
      this.loading = true;
      try {
        const res = await axios.post(
          expressService_dotnet +
            "CoreMessage/get-chat-channel-list?shopId=" +
            this.shopId,
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token_api,
            },
          }
        );
        const list = (res.data && res.data.data) || [];
        this.channels = list;
        // default = channel แรก (หรือ match activeId ถ้ามี)
        if (list.length > 0 && !this.selectedItem) {
          const initial = this.activeId
            ? list.find((c) => c.platformConnectionID === this.activeId) ||
              list[0]
            : list[0];
          this.selectedItem = initial;
          this.onChange(initial);
        }
      } catch (err) {
        this.$swal &&
          this.$swal({
            icon: "error",
            title: this.use_language.load_channel_failed,
            text: err.message || this.use_language.error,
          });
      } finally {
        this.loading = false;
      }
    },
    onChange(item) {
      if (!item) return;
      this.$emit("select", {
        platformConnectionID: item.platformConnectionID,
        platformID: item.platformID,
        channel: item,
      });
    },
  },
};
</script>

<style scoped>
.channel-dropdown {
  width: 100%;
}
</style>